define(["jquery", "underscore", 'app-common/component/api-call', "common/lib/date"], function($, _, apiCall) {

    var logTemplate;

	function findUserStatus(rawRoles) {
		if(_.include(rawRoles, "USER")) {
			return "bookkeeper";
		}
		if(_.include(rawRoles, "CLIENT")) {
			return "client";
		}
	}

	function formatDate(timestamp) {
		var date = new Date(timestamp);
		return date.toString("dddd, MMM d, yyyy &#97;&#116; h:mm tt");
	}

    function formatTime(timestamp) {
        var date = new Date(timestamp);
        return date.toString("h:mm tt");
    }

	function buildHistoryLog(changeLog) {
		if(changeLog && _.isArray(changeLog) && !_.isEmpty(changeLog)) {
			for(var i = 0; i < changeLog.length; i++) {
				changeLog[i].changeNumber = changeLog.length - i;
				changeLog[i].simpleDate = formatDate(changeLog[i].dateTimeStampMsec);
				changeLog[i].modificatorPersonStatus = findUserStatus(changeLog[i].modificatorPersonRoles);

                for(var j = 0; j < changeLog[i].changesEntries.length; j++) {
                    changeLog[i].changesEntries[j].time = formatTime(changeLog[i].dateTimeStampMsec);
                }
			}
		} else {
			changeLog = [];
		}

		return changeLog;
	}



	function init(jeId, template, loadData, callback) {
		if(!jeId) return;

        logTemplate = template;
		if (loadData === true) {
            //load and fill with data
            var promise = apiCall("document", jeId + "/jeHistory", "GET");
            promise.done(function(data) {
                var log = buildHistoryLog(data);
                var logHtml = _.template(logTemplate, {changeLog: log, loadedData: true});
                if($.isFunction(callback)) callback(logHtml);
            });
        } else {
            //load empty
            var log = buildHistoryLog();
            var logHtml = _.template(logTemplate, {changeLog: log, loadedData: false});
            if($.isFunction(callback)) callback(logHtml);
            $("#load-history-message").on("click", function() {
                init(jeId, template, true, callback);
            });
        }
	}

	return {
		init: init
	}
});
